import React, { FC, useEffect, useMemo, useRef } from 'react'
import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { useOnScreen } from 'shared/hooks'
import loadMoreLogo from 'assets/animatedIcons/loadMoreLogo.json'

import { LoadMoreProps } from './LoadMore.props'

import './LoadMore.scss'
import { ConditionRender } from 'components'
import { cn } from 'shared/utils'

const LoadMore: FC<LoadMoreProps> = ({ onLoad, isItemsLoading, itemsCount, itemsTotal, label = '' }) => {
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const lottieRef = useRef<LottieRefCurrentProps | null>(null)
  const isVisible = useOnScreen(loadMoreRef)
  const shouldLoadMore = useMemo(
    () => isVisible && !isItemsLoading && itemsCount < itemsTotal,
    [isItemsLoading, isVisible, itemsCount, itemsTotal]
  )

  useEffect(() => {
    if (shouldLoadMore) {
      onLoad()
    }
  }, [onLoad, shouldLoadMore])

  useEffect(() => {
    if (isItemsLoading) {
      lottieRef.current?.goToAndPlay(0, true)
    } else {
      lottieRef.current?.goToAndStop(100, true)
    }
  }, [isItemsLoading])

  return (
    <>
      <ConditionRender
        condition={!!label}
        component={
          <div className="load-more__label">
            {itemsCount}&nbsp;out of&nbsp;{itemsTotal}&nbsp;{label}
          </div>
        }
      />
      <div ref={loadMoreRef} className={cn('load-more', { 'load-more--loading': isItemsLoading })}>
        <Lottie lottieRef={lottieRef} animationData={loadMoreLogo} loop={true} className="load-more__logo" />
      </div>
    </>
  )
}

export default LoadMore
